import { Component, OnInit, inject } from '@angular/core';
import { AuthenticationContextDatasourceService } from '../../../backend/datasource';

@Component({
  selector: 'eidas-authentication',
  templateUrl: './eidas-authentication.component.html',
  styleUrl: './eidas-authentication.component.scss'
})
export class EidasAuthenticationComponent implements OnInit {
  private authenticationContextDatasource = inject(AuthenticationContextDatasourceService);

  ngOnInit(): void {
    window.location.href =
      window.location.origin +
      '/api/eidas/request/HTTP-Redirect?id=' +
      this.authenticationContextDatasource.getSessionId();
  }
}
